<template>
  <div class="doctor-settings">
    <div class="main-row" v-if="doctorsList && doctorsList.data">
      <template v-for="doctor in doctorsList.data.$values">
        <v-card
          :class="{ 'not-confirmed': !doctor.confirmed }"
          :key="doctor.$id"
          :style="{'border-radius': '16px'}"
          elevation="1"
        >
          <v-card-text>
            <div class="main-row justify-center">
              <div class="doctor-title">{{ !doctor.active && (doctor.confirmed || !doctor.confirmed) ? 'Inactive' : doctor.active && !doctor.confirmed ? 'Pending Invitation' : '' }}&nbsp;</div>
            </div>
            <div class="main-row">
              <div class="avatar">
                <img :src="doctor.logoURL || 'data:image/png;base64,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'" :alt="doctor.name">
              </div>
              <div class="information">
                <v-row no-gutters>
                  <v-col cols="12" class="information-column">
                    <!-- <span class="information__title">Practitioner: </span> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="information__description full-name" v-bind="attrs"
                              v-on="on" @click="copyValue">{{doctor.firstName || ''}} {{doctor.lastName}}</span>
                      </template>
                      <span>Click to Copy</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="information-column">
                    <span class="information__title">Patients: </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="information__description" v-bind="attrs"
                              v-on="on" @click="copyValue">{{doctor.patientsCount || '-'}}</span>
                      </template>
                      <span>Click to Copy</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="information-column">
                    <span class="information__title">Phone: </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="information__description" v-bind="attrs"
                              v-on="on" @click="copyValue">{{doctor.phoneNumber || '-'}}</span>
                      </template>
                      <span>Click to Copy</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="information-column">
                    <span class="information__title">Email: </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="information__description" v-bind="attrs"
                              v-on="on" @click="copyValue">{{doctor.email || '-'}}</span>
                      </template>
                      <span>Click to Copy</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <div class="actions">
                <actions
                  v-if="doctor.active && doctor.confirmed"
                  :items="doctorActions"
                  v-on="actionListener"
                  :item="{ doctor }"
                />
                <actions
                  :isMenuList="true"
                  v-if="!doctor.active"
                  :items="doctorActionsInactive"
                  v-on="actionListener"
                  :item="{ doctor }"
                />
                <actions
                  :isMenuList="true"
                  v-if="doctor.active && !doctor.confirmed"
                  :items="doctorActionsPending"
                  v-on="actionListener"
                  :item="{ doctor }"
                />
              </div>
<!--              <v-divider
                vertical
              ></v-divider>-->
            </div>
          </v-card-text>
        </v-card>
      </template>
    </div>
    <v-row class="mt-2">
      <v-col class="d-flex flex-row">
        <Button dark
                btn-bg="dark-green"
                height="45"
                :styles="{ 'border-radius': '16px' }"
                :disabled="userProfile.UserType === 'Doctor'"
                @click="TOGGLE_DIALOG({ name: 'inviteDoctors', isOpen: true, title: ' Invite Additional Practitioner' })">
        <v-icon>mdi-plus</v-icon>
          <span>Invite Practitioner</span>
        </Button>
        <Button outlined
                height="45"
                class="ml-1"
                :styles="{ 'border-radius': '16px', 'border': '1px solid #008C89' }"
                @click="handleRefresh">
          <v-icon color="#0000008a">mdi-refresh</v-icon>
          <span style="color: #0000008a">Refresh</span>
        </Button>
      </v-col>
    </v-row>
    <invite-doctors v-if="dialogs.inviteDoctors.isOpen" @showPopup="showPopup" />
    <operations-with-doctors v-if="dialogs.operationsWithDoctorDialog.isOpen" @showPopup="showPopup"/>
    <confirm v-if="dialogs.confirm.isOpen" @showPopup="showPopup" />
    <div class="custom-alert">
      <v-alert
        color="#7ac1fb"
        dismissible
        type="info"
        v-model="alertIsOpen"
      >
        <span style="font-size: 14px;">{{popupMessage}}</span>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Button from '@/components/elements/Button'
import actions from '@/components/layouts/actions'
import { trackEvent } from '@/utils/analytics'

export default {
  name: 'doctorSettings',
  components: {
    InviteDoctors: () => import('@/components/layouts/dialogs/invite-doctors'),
    Button,
    actions,
    OperationsWithDoctors: () => import('@/components/layouts/dialogs/operations-with-doctor'),
    confirm: () => import('@/components/layouts/dialogs/confirm-dialog.vue')
  },
  data: () => ({
    popupMessage: null,
    alertIsOpen: false,
    doctorActions: [
      { icon: 'mdi-swap-horizontal', color: 'grey', name: 'Replace Practitioner', method: 'reassignDoctor' },
      { icon: 'mdi-lock-reset', color: 'grey', name: 'Reset Password', method: 'resetPassword' },
      { icon: 'mdi-trash-can-outline', color: 'grey', name: 'Make Inactive', method: 'makeInactive' }
    ],
    doctorActionsInactive: [
      // { icon: '', color: 'grey', name: '', method: '' },
      { icon: 'mdi-arrow-u-left-top', color: 'grey', name: 'Reactivate', method: 'activateDoctor' }
    ],
    doctorActionsPending: [
      { icon: 'mdi-email-sync-outline', color: 'grey', name: 'Resend Invitation', method: 'reInviteDoctor' }
    ]
  }),
  mounted () {
    this.getListOfDoctors()
  },
  methods: {
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    ...mapActions('organizations', ['getListOfDoctors', 'onActivateDoctor', 'onDeactivateDoctor', 'onResendInvitationDoctor']),
    copyValue ($event) {
      const textArea = document.createElement('textarea')
      textArea.value = $event.target.innerText
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      textArea.remove()
    },
    handleRefresh () {
      trackEvent(this, 'refresh_practitioners_list', 'Practitioner', 'Refresh Practitioners')
      this.getListOfDoctors()
    },
    showPopup ({ type, data }) {
      switch (type) {
        case 'deactivate-doctor':
          trackEvent(this, 'make_inactive', 'Practitioner', 'Practitioner Was Successfully Deactivated')
          this.alertIsOpen = true
          this.popupMessage = 'Deactivating was completed successfully.'
          this.TOGGLE_DIALOG({ name: 'operationsWithDoctorDialog', isOpen: false })
          this.getListOfDoctors()
          break
        case 'activating-doctor':
          trackEvent(this, 'make_active', 'Practitioner', 'Practitioner Was Successfully Activated')
          this.alertIsOpen = true
          this.popupMessage = 'Activating was completed successfully.'
          this.TOGGLE_DIALOG({ name: 'operationsWithDoctorDialog', isOpen: false })
          this.getListOfDoctors()
          break
        case 'reassign-doctor':
          trackEvent(this, 'replace_practitioner', 'Practitioner', 'Practitioner Was Successfully Reassigned')
          this.alertIsOpen = true
          this.popupMessage = 'Reassigning was completed successfully.'
          this.TOGGLE_DIALOG({ name: 'operationsWithDoctorDialog', isOpen: false })
          this.getListOfDoctors()
          break
        case 'invite-doctors':
          trackEvent(this, 'invite_pactitioner', 'Practitioner', 'Practitioner Was Successfully Invited')
          this.alertIsOpen = true
          this.popupMessage = 'Invite was sent successfully.'
          this.TOGGLE_DIALOG({ name: 'inviteDoctors', isOpen: false })
          this.getListOfDoctors()
          break
        case 'reset-password':
          trackEvent(this, 'reset_password', 'Practitioner', 'Password Reset Email Was Sent to the Practitioner')
          this.alertIsOpen = true
          this.popupMessage = 'Email send to Practitioner.'
          this.TOGGLE_DIALOG({ name: 'confirm', isOpen: false })
          this.getListOfDoctors()
          break
      }
    },
    reassignDoctor (data) {
      this.TOGGLE_DIALOG({ name: 'operationsWithDoctorDialog', title: 'Confirm reassign Practitioner', isOpen: true, data: data.data.doctor, type: 'reassign-doctor', methodSave: 'onReassignDoctor' })
    },
    activateDoctor (data) {
      this.TOGGLE_DIALOG({ name: 'operationsWithDoctorDialog', title: 'Confirm activating Practitioner', isOpen: true, data: data.data.doctor, type: 'activating-doctor', methodSave: 'onActivateDoctor' })
    },
    async makeInactive (data) {
      this.TOGGLE_DIALOG({ name: 'operationsWithDoctorDialog', title: 'Confirm deactivating Practitioner', isOpen: true, data: data.data.doctor, type: 'deactivate-doctor', methodSave: 'onDeactivateDoctor' })
    },
    async resetPassword (data) {
      this.TOGGLE_DIALOG({ name: 'confirm', title: 'Please confirm Reset Password', isOpen: true, type: 'reset-password', id: data.data.doctor.id,  action: 'organizations/onResetPassword', })
    },
    reInviteDoctor (data) {
      trackEvent(this, 'resend_invitation', 'Practitioner', 'The Practitioner Was Successfully Reinvited', {
        doctor_id: data.data.doctor.id
      })

      this.onResendInvitationDoctor({ id: data.data.doctor.id })
    }
  },
  computed: {
    ...mapState({
      userProfile: state => state.userProfile,
      doctorsList: state => state.organizations.doctors
    }),
    dialogs () {
      return this.$store.state.dialogs
    },
    actionListener: function () {
      var vm = this
      return Object.assign({},
        this.$listeners,
        {
          action: function (event) {
            vm[event.params.method](event)
          }
        }
      )
    }
  },
  watch: {
    alertIsOpen (val) {
      const self = this
      if (val) {
        setTimeout(function () {
          self.alertIsOpen = false
        }, 5000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.doctor-settings {
  min-height: 67vh;
  .main-row {
    ::v-deep .v-card {
      background: white!important;
      &.not-confirmed {
        background: #ebebeb8a!important;
      }
    }
    display: flex;
    flex-wrap: wrap;
    column-gap: 1rem;
    row-gap: 1rem;
    align-items: center;
    .doctor-title {
      color: black;
      font-weight: 600;
      font-size: 17px;
    }
    .avatar {
      width: 100px;
      height: 100%;

     img {
       object-fit: cover;
       width: 100%;
       border-radius: 50%;
     }
    }

    .information {
      width: 180px;
      .row {
        cursor: pointer;
      }
      .information-column {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &__title {
        font-size: 14px;
        color: #718096;
      }
      &__description.full-name {
        color: black;
        font-weight: 600;
      }
      &__description {
        font-weight: normal;
        color: #292b2f;
      }
    }
  }
  .custom-alert {
    max-width: 300px;
    position: fixed;
    top: 10px;
    right: 20px;
    z-index: 100;
  }
}
</style>
